import { render, staticRenderFns } from "./shjz.vue?vue&type=template&id=1fb4d81c&scoped=true"
import script from "./shjz.vue?vue&type=script&lang=js"
export * from "./shjz.vue?vue&type=script&lang=js"
import style0 from "./shjz.vue?vue&type=style&index=0&id=1fb4d81c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fb4d81c",
  null
  
)

export default component.exports